import React from "react";
import Loading from "./Loading";

export default function Page(props) {
  if (props.error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[200px] p-4">
        <p className="font-raleway text-base text-gray-600 text-center">
          Unable to load content. Please try again later.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="mt-4 bg-[#DD8732] text-white py-2 px-4 rounded-full font-raleway font-bold text-xs hover:bg-opacity-80"
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div>
      <Loading isLoading={props.isLoading}>{props.children}</Loading>
    </div>
  );
}
